import { DEGEN_LEVERAGE_ARRAY } from '@ui/constants/uiConfig';
import { getPairMaxLeverage } from '@ui/features/MassiveToken/utils/getPairMaxLeverage';
import { TradePair } from '@ui/types/tradePair';
import { Nullable } from 'vitest';

export const getLeverageArray = ({
  isDegen,
  baseTradePair,
}: {
  isDegen: boolean;
  baseTradePair: Nullable<TradePair>;
}) => {
  const maxStandardLeverage = getPairMaxLeverage({ tradePair: baseTradePair });
  const standardLeverageArray = maxStandardLeverage
    ? [
        {
          sliderValue: maxStandardLeverage,
          value: maxStandardLeverage,
        },
      ]
    : [];

  return isDegen
    ? [...standardLeverageArray, ...DEGEN_LEVERAGE_ARRAY]
    : standardLeverageArray;
};
